/* eslint-disable @stylistic/quotes */

import axios from 'axios';

// todo: remove localhost

// export const getPolygonCoordinates = (dblink) => {
//     return axios.get(`https://localhost:7218/api/geoinfo/parcel/` + dblink);
// };

export const getDevelopmentApplicationCached = (url, caseNumber) => {
    return axios.get(`${url}`, {params: { caseNumber: caseNumber}});
};

export const getAllDevelopmentApplicationsCached = (url) => {
    return axios.get(`${url}`);
};